import { ChangeDetectorRef, ViewChild, OnInit, Component, Input, Output, EventEmitter } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { AuthenticationService, AuthorizationService, StorageManagerService, AuthWindowService } from '../../../shared/services';
import { Utilities } from '../../../shared/services/utilities';
import { ESGSubmissionService } from '../../../shared/services/esg-submission-service';
import { ISubmission } from '../../../shared/models/submission.model';
import { ISubmissionItem } from '../../../shared/models/submission-item.model';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { OidcSecurityService,AuthOptions } from 'angular-auth-oidc-client';

@Component({
    selector: 'app-esig-modal',
    styleUrls: ['./esig-modal.component.scss'],
    templateUrl: 'esig-modal.component.html',
    standalone: false
})
export class EsigModalComponent implements OnInit {
  @ViewChild('esigModal') esigModal: any;
  @ViewChild('postAuthMessageModal') postAuthMessageModal: any;
  @ViewChild('noEsgAccessModal') noEsgAccessModal: any;
  @Output() isSuccessfulySubmitted = new EventEmitter<boolean>(false);
  clientName: string;
  clientId: number;
  clientGuid: string;
  @Input() fileName: string;
  @Input() documentType: string;
  @Input() splVersionNumber: string;
  @Input() formRevisionId: string;
  @Input() orderId: string;
  localFileName: string;
  localDocumentType: string;
  localSplVersionNumber: string;
  localFormRevisionId: string;
  localOrderId: string;
  
  hasEsgAccess: boolean;
  userNameField: any;
  passwordField: any;
  submitterName: string;
  submissionDate: string;
  submitterUserGuid: string;
  submission: ISubmission[] = [];
  submissionItem: ISubmissionItem;
  showloading: boolean = false;

  // Modal for selecting SPL Version
  confirmDialogSelection$: Subject<boolean> = new Subject<boolean>();
  isBuild: boolean;
  invalidSplVersion: boolean;
  updatedSPLVersion: string;
  sendModalVisible: boolean = false;
  sub: Subscription;
  formData: any;

  // Modal properties
  position: object = { X: 'center', Y: 'center' };
  modalWidth = '30%';
  modalHeight = 'auto';
  animationSettings: Object = { effect: 'Zoom' };
  isModal = true;
  subscription: any;
  eSignatureErrorMessage: any;
  loginName: any;
  receivedMessage: any = null;
  authChannel: BroadcastChannel | null = null;

  constructor(private cdRef: ChangeDetectorRef,
    private storageService: StorageManagerService,
    private authService: AuthenticationService,
    private submissionService: ESGSubmissionService,
    private authorizationService: AuthorizationService,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private oidc: OidcSecurityService,
    private authWindowService: AuthWindowService) {
 
  }

  ngOnInit() {
    this.submitterName = typeof this.storageService.read('userData') === 'object' ? this.storageService.read('userData')?.name : '';
    this.submissionDate = new Date().toLocaleString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
    const customer = Utilities.getCustomerFromStorage(this.storageService);
    this.clientName = customer ? customer.customerName : '';
    this.clientId = customer ? customer.customerId : null;
    this.clientGuid = customer ? customer.customerGuid : null;
    this.hasEsgAccess = this.authorizationService.hasAccessToAppVariant('SSDrugProducts-ESG', customer);
    this.loginName = this.storageService.read('userData').preferred_username;
    this.submitterUserGuid =  this.storageService.read('userGuid');

    try {
      this.authChannel = new BroadcastChannel('auth_channel');
      this.authChannel.onmessage = (event) => {
        this.processAuthData(event.data);
      };
    } catch (e) {
      console.error('BroadcastChannel not supported', e);
    }
    window.addEventListener('message', this.receiveMessage, false);
  }

  setLocalVariables() {
    this.localFileName = this.fileName ? this.fileName.slice() : '';
    this.localDocumentType = this.documentType ? this.documentType.slice() : '';
    this.localFormRevisionId = this.formRevisionId ? this.formRevisionId.slice() : '';
    this.localSplVersionNumber = this.splVersionNumber ? this.splVersionNumber.slice() : '';
    this.localOrderId = this.orderId ? this.orderId.slice() : '';
  }

  showEsignatureModal() {
    if (!this.fileName) {
      return;
    }
    this.setLocalVariables();
    this.eSignatureErrorMessage = '';

    if (this.hasEsgAccess) {
      this.sendModalVisible = true;
      this.esigModal.show();
    }
    else {
      this.noEsgAccessModal.show();
    }
  }

  eSigCancel() {
    const btnConfirm: any = document.getElementById('btnConfirm');
    btnConfirm.disabled = false;
    this.esigModal.hide();
  }

  confirmClicked() {
    const btnConfirm: any = document.getElementById('btnConfirm');
    btnConfirm.disabled = true;
    this.eSignatureErrorMessage = '';

    if (this.authWindowService.authWindow && !this.authWindowService.authWindow.closed) {
      this.authWindowService.authWindow.focus();
      return;
    }

    const width = 600;
    const height = 600;
    const left = window.screenX + (window.outerWidth - width) / 2;
    const top = window.screenY + (window.outerHeight - height) / 2;

    this.authWindowService.authWindow = window.open(`${window.location.origin}/external-login`, 'eSignature Authentication', `width=${width},height=${height},top=${top},left=${left}`);

    if (!this.authWindowService.authWindow) {
      btnConfirm.disabled = false;
      this.eSignatureErrorMessage ='Authentication window was blocked. Please allow pop-ups for this site.';
    }
  }

  afterAuthSuccess(btnConfirm: any) {
    btnConfirm.disabled = false;
    this.submissionService.createDrugProductSubmission(this.submission).subscribe(
        async (response) => {
        this.showloading = false;
        this.postAuthMessageModal.show();
        this.esigModal.hide();
        this.isSuccessfulySubmitted.next(true);
        this.submission = [];
        },
        error => {
        this.showloading = false;
        this.toastr.error(`${error && error.errorMessage ? error.errorMessage : error}`);
        this.postAuthMessageModal.hide();
        this.esigModal.hide();
        this.submission = [];
        },
    );
  }

  buildDrugProductSubmissionModel() {
    this.submission = [];
    let componentName = this.route.snapshot.component.name;
    //angular 19 added an undersore to the string removed it to normalise the string
    if (componentName) 
    {
        componentName = componentName.replace('_', '');
    }
    let submissionItemType: number;
    let path: string;

    if (componentName.toLowerCase().startsWith('bncc')) {
      submissionItemType = 6; // 6 = SPL-BNCC
      path = `BNCC/Build/${this.localFormRevisionId}`;
    }

    if (componentName.toLowerCase().startsWith('lcr')) {
      submissionItemType = 5; // 5 = SPL-LCR
      path = `LCR/Build/${this.localFormRevisionId}`;
    }

    if (componentName.toLowerCase().startsWith('er')) {
      submissionItemType = 4; // 4 = SPL_ER
      path = `ER/Build/${this.localFormRevisionId}`;
    }

    if (componentName.toLowerCase().startsWith('product')) { // product labeling and product dashboard uses same path and same item type code
      submissionItemType = 3; // 3 = SPL-LL
      // If we are sending a submission from LL, use orderId in file path.
      path = `ORDER/Delivery/${this.localOrderId}`;
    }

    let submissionBuilder = {
      submissionId: 0,
      submissionGuid: '',
      customerId: this.clientId,
      distributionChannel: 'US_FDA_SPL', // hard-coded to this string
      submissionStatusCode: 4, // hard-coded to 4 = SubmissionInProcess
      submissionQueueStatusCode: 2, // hard-coded to 2 = Pending
      submissionTypeCode: 11, // hard-coded to 11 = FdaSubmission
      submissionItems: [{
        submissionId: 0,
        submissionItemTypeCode: submissionItemType,
        rootId: '',
        formRevisionId: this.localFormRevisionId?.toString(),
        sourceFilePath: `${this.clientGuid}/${path}`,
        sourceFileName: this.localFileName.toString(),
      }],
      submissionXMLText: '',
      submissionXMLFileLocation: '',
      submissionCompressedFileCloudLocation: '',
      submissionCompressedFileName: '',
      createUserGuid: this.submitterUserGuid,
      changeUserGuid: this.submitterUserGuid,
      customerGuid: this.clientGuid,
      createDate: '',
      changeDate: '',
      submissionStatusDescription: '',
      submissionCoreId: '',
      submissionItemTypeDescription: '',
      rootId: '',
      formVersion: '',
      formRevisionId: '',
    };

    this.submission.push(submissionBuilder);
  }

  postAuthClose() {
    this.postAuthMessageModal.hide();
  }

  noAccessModalClose() {
    this.noEsgAccessModal.hide();
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
    if (this.authChannel) {
        this.authChannel.close();
    }
    window.removeEventListener('message', this.receiveMessage);
  }

  processAuthData(data: any) {
    if (data?.preferred_username === undefined) {
      return; 
    }
    const btnConfirm: any = document.getElementById('btnConfirm');
    if (data && data.preferred_username && data.preferred_username.toLowerCase() === this.loginName.toLowerCase()) {
        this.buildDrugProductSubmissionModel();
        this.afterAuthSuccess(btnConfirm);
    } else {
        this.showloading = false;
        if(btnConfirm) btnConfirm.disabled = false;
        this.toastr.error(`eSignature username must match logged in username`);
        this.eSignatureErrorMessage = "eSignature username must match logged in username";
        this.postAuthMessageModal.hide();
        this.submission = [];
    }
  }

  receiveMessage = (event: MessageEvent) => {
    if (event.origin !==  window.location.origin) {
        return; // Don't process messages from unknown origins
    }
    this.processAuthData(event.data);
  };
}
